export default (screenWidth: number): boolean => {
    return window.innerWidth >= screenWidth;
}